import * as React from 'react'

import { WELCOME_SNACKBAR_STORAGE_KEY } from './shared'

import { EXTRA_EXTRA_LARGE_ICON_BASE_SRC, PostNavigationBanner } from '../../../../Shared'
import { requestPut } from '../../../../../modules/request'

const V2_PATH = '/teachers/classrooms/manage_activities_v2'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`

const ManageActivitiesV2OptInBanner = ({ userId, }: { userId: number }) => {
  const localStorageKey = `manageActivitiesV2BannerClosedForUser${userId}`

  const [previouslyClosedBanner, setPreviouslyClosedBanner] = React.useState(window.localStorage.getItem(localStorageKey))
  const savingRef = React.useRef(false)

  if (previouslyClosedBanner) { return null }

  const handleOptInFailure = () => {
    savingRef.current = false
    window.alert('Something went wrong turning that on. Please try again, or use My Account > Beta Features.')
  }

  const handleOptIn = () => {
    if (savingRef.current) { return }
    savingRef.current = true
    const request = requestPut('/teacher_infos', { uses_manage_activities_v2: true }, () => {
      try { window.sessionStorage.setItem(WELCOME_SNACKBAR_STORAGE_KEY, 'true') } catch { }
      window.location.replace(V2_PATH)
    }, handleOptInFailure)
    request?.catch?.(handleOptInFailure)
  }

  const handleCloseBanner = () => {
    window.localStorage.setItem(localStorageKey, 'true')
    setPreviouslyClosedBanner('true')
  }

  return (
    <section className="manage-activities-v2-opt-in-banner-section">
      <div className="container">
        <PostNavigationBanner
          bannerColor="teal"
          bannerStyle="light-mode"
          bodyText="Rebuilt from the ground up based on teacher feedback. See student progress at a glance and find what you need faster. You can switch back anytime in My Account."
          buttons={[
            {
              onClick: handleOptIn,
              text: 'Try it now',
            }
          ]}
          closeAria="Close this invitation"
          closeIconSrc={closeIconSrc}
          handleCloseCard={handleCloseBanner}
          primaryHeaderText="You're invited to try the new Manage Activities experience"
          rightSide={<img alt="" className="banner-icon" height="90" src={`${EXTRA_EXTRA_LARGE_ICON_BASE_SRC}/ship.svg`} width="90" />}
          tagText="beta"
        />
      </div>
    </section>
  )
}

export default ManageActivitiesV2OptInBanner
